<template>
	<div id="app">
		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App',

		data() {
			return {

			}
		},
		mounted() {
			if(this._isMobile()) {
				this.$router.replace('/m_index');
			} else {
				this.$router.replace('/pc_index');
			}
		},
		methods: {　
			_isMobile() {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				return flag;
			}
		}

	}
</script>

<style>
	body {
		width: 100%!important;
		height: 100%!important;
	}
	
	#app {}
</style>


// WEBPACK FOOTER //
// src/App.vue